import styled from "styled-components";

import Home from "./components/Home";
import About from "./components/About";
import Expertises from "./components/Expertises";
import Navbar from "./components/Navbar";
import Products from "./components/Products";
import Testmonials from "./components/Testmonials";
import FirstFooter from "./components/FirstFooter";
import Blog from "./components/Blog";
import Contact from "./components/Contact";

const Main = styled.div`
  width: 100vw;
  height: auto;

  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  scroll-behavior: smooth;
`;

function App() {
  return (
    <Main>
      <Navbar />
      <Home />
      <About />
      <Expertises />
      <Products />
      <Testmonials />
      <FirstFooter />
      <Blog />
      <Contact />
    </Main>
  );
}

export default App;
